/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userJoinLoyaltyCreateStatus200Schema = z.any();

export const userJoinLoyaltyCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userJoinLoyaltyCreateStatus503Schema = errorResponseSchema;

export const userJoinLoyaltyCreateResponseSchema = z.union([
	userJoinLoyaltyCreateStatus200Schema,
	userJoinLoyaltyCreateStatus401Schema,
	userJoinLoyaltyCreateStatus503Schema,
]);
